'use client'

import * as React from 'react'
import * as CheckboxPrimitive from '@radix-ui/react-checkbox'
import { CheckIcon } from 'lucide-react'

import { cn } from '@/lib/utils'

function Checkbox({
  className,
  ...props
}: React.ComponentProps<typeof CheckboxPrimitive.Root>) {
  return (
    <CheckboxPrimitive.Root
      data-slot="checkbox"
      className={cn(
        'peer size-4 shrink-0 rounded-[4px] border-2 shadow-xs transition-shadow outline-none',
        // Unchecked state - visible in both modes
        'bg-transparent border-gray-400',
        'dark:border-gray-500 dark:bg-gray-700/50',
        // Checked state - bright green
        'data-[state=checked]:bg-[#7ed957] data-[state=checked]:border-[#7ed957] data-[state=checked]:text-white',
        // Focus states
        'focus-visible:ring-2 focus-visible:ring-[#7ed957]/50 focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        // Disabled state
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <CheckboxPrimitive.Indicator
        data-slot="checkbox-indicator"
        className="flex items-center justify-center text-current transition-none"
      >
        <CheckIcon className="size-3.5" />
      </CheckboxPrimitive.Indicator>
    </CheckboxPrimitive.Root>
  )
}

export { Checkbox }
